import { OCConnectWidget } from './OCConnect';

export * from './OCConnect';

export default OCConnectWidget;
